import _ from 'lodash';

import { createApiReducer, chainReducers, INITIAL_API_STATE } from 'src/api';

import {
  FETCH_FORM_DATA_START,
  FETCH_FORM_DATA_SUCCESS,
  FETCH_FORM_DATA_FAILURE,
} from './actions';

const transformFormData = response => {
  return {
    industries: response.industries.map(i => ({
      id: i.id,
      name: i.industry_type,
      licenseTypes: i.industry_license_types.map(lt => ({
        id: lt.id,
        name: lt.license_type_type,
      })),
      productTypes: i.industry_product_types.map(pt => ({
        id: pt.id,
        name: pt.product_type_type,
      })),
      activities: i.industry_activities.map(a => ({
        id: a.id,
        name: a.activity_type,
      })),
      documentTypes: i.industry_document_types.map(item => ({
        id: item.id,
        name: item.document_type_type,
        description: item.document_type_description,
      })),
      consentTypes: i.industry_consent_types.map(item => ({
        id: item.id,
        name: item.consent_type_type,
        shortDescription: item.consent_type_short_description,
        longDescription: item.consent_type_long_description,
        isBackgroundCheck: item.consent_type_is_background_check,
      })),
    })),
    addressTypes: response.address_types.map(at => ({
      id: at.id,
      name: at.address_type_type,
    })),
    depositProducts: response.deposit_products.map(dp => ({
      id: dp.id,
      name: dp.deposit_product_type,
    })),
    loanProducts: response.loan_products.map(lp => ({
      id: lp.id,
      name: lp.loan_product_type,
    })),
    services: response.services.map(s => ({
      id: s.id,
      name: s.service_type,
    })),
    businessEntityTypes: response.business_entity_types.map(bet => ({
      id: bet.id,
      name: bet.business_entity_type_type,
    })),
    personRoles: response.person_roles.map(item => ({
      id: item.id,
      name: item.user_role_role,
      isFiAdmin: item.is_fi_admin,
      isFiPrimaryAdmin: item.is_fi_primary_admin,
      isMerchantAdmin: item.is_merchant_admin,
      isMerchantNonAdmin: item.is_merchant_non_admin,
      isMerchantPrimaryAdmin: item.is_merchant_primary_admin,
      isSuperAdmin: item.is_super_admin,
    })),
    personLicenseTypes: response.user_license_types.map(item => ({
      id: item.id,
      name: item.user_license_type_type,
    })),
    financialInstitutionTypes: (response.financial_institution_types || []).map(
      item => ({
        id: item.id,
        name: item.financial_institution_type_type,
      })
    ),
  };
};

const formDataReducer = createApiReducer(
  [FETCH_FORM_DATA_START, FETCH_FORM_DATA_SUCCESS, FETCH_FORM_DATA_FAILURE],
  (payload, state) => {
    return { ...state.data, ...transformFormData(payload) };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

export const formData = chainReducers(INITIAL_API_STATE, formDataReducer);
